import type { Components, Theme } from "@mui/material";

export const components: Components<Theme> = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        // Raised for readability in #2150. Kept deliberately, and off the type scale — see
        // docs/engineering/design/frontend_design_system_design.md, decision 6.
        fontSize: "1rem",
      },
    },
  },
};
